import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ListUsers from './components/ListUsers';
import CreateUser from './components/CreateUser';
import EditUser from './components/EditUser';
import ListProjects from './components/ListProjects';
import Project from './components/Project';
import Homepage from './components/Homepage';
import Layout from './components/layout/Layout';
import Signup from './components/Signup';

import './scss/theme.scss';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            index
            element={
              <Layout>
                <Homepage />
              </Layout>
            }
          />
          <Route
            path="/signup"
            element={
              <Layout>
                <Signup />
              </Layout>
            }
          />
          <Route
            path="/users"
            element={
              <Layout>
                <ListUsers />
              </Layout>
            }
          />
          <Route
            path="/user/create"
            element={
              <Layout>
                <CreateUser />
              </Layout>
            }
          />
          <Route
            path="/user/:id/edit"
            element={
              <Layout>
                <EditUser />
              </Layout>
            }
          />
          <Route
            path="/projects/:user_id"
            element={
              <Layout>
                <ListProjects />
              </Layout>
            }
          />
          <Route
            path="/project/:id"
            element={
              <Layout>
                <Project />
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
